import { api, ApiError } from "./client";
import type { CampaignMoveResult, CampaignRun, CampaignStage } from "../types";

export const campaignApi = {
  getStages: () => api.get<CampaignStage[]>("/campaign/stages"),
  enter: (stageId: number) =>
    api.post<CampaignRun>("/campaign/enter", { stage_id: stageId }),
  getRun: (stageId?: number) =>
    api.get<CampaignRun>(`/campaign/run${stageId != null ? `?stage_id=${stageId}` : ""}`),
  fetchActiveRun: async (): Promise<CampaignRun | null> => {
    try {
      return await api.get<CampaignRun>("/campaign/run");
    } catch (e) {
      if (e instanceof ApiError && e.status === 404) return null;
      throw e;
    }
  },
  move: (runId: number, nodeId: string, autoBattleMode?: string) =>
    api.post<CampaignMoveResult>("/campaign/move", {
      run_id: runId,
      node_id: nodeId,
      auto_battle_mode: autoBattleMode,
    }),
  abandon: (stageId?: number) =>
    api.post<{ ok: boolean }>(
      `/campaign/abandon${stageId != null ? `?stage_id=${stageId}` : ""}`,
    ),
};
